/**
 * Enum Theo dõi
 * dmha 12.03.2024
 */
export default {
  // tất cả
  All: 0, 
  // Thêm mới
  AddNew: 1, 
  // Đã sửa
  Edited: 2, 
  // Đã ban hành
  Enacted: 3, 
};
